// Permission constants matching backend
export const PERMISSIONS = {
  // User Management
  USERS: {
    VIEW: 'users.view',
    CREATE: 'users.create',
    UPDATE: 'users.update',
    DELETE: 'users.delete',
    MANAGE_ROLES: 'users.manage_roles',
  },

  // Company Settings
  COMPANY: {
    VIEW: 'company.view',
    UPDATE: 'company.update',
    SETTINGS: 'company.settings',
  },

  // Financial - Invoices
  INVOICES: {
    VIEW: 'invoices.view',
    CREATE: 'invoices.create',
    UPDATE: 'invoices.update',
    DELETE: 'invoices.delete',
    SEND: 'invoices.send',
    VOID: 'invoices.void',
  },

  // Financial - Bills
  BILLS: {
    VIEW: 'bills.view',
    CREATE: 'bills.create',
    UPDATE: 'bills.update',
    DELETE: 'bills.delete',
    APPROVE: 'bills.approve',
  },

  // Financial - Payments
  PAYMENTS: {
    VIEW: 'payments.view',
    CREATE: 'payments.create',
    UPDATE: 'payments.update',
    DELETE: 'payments.delete',
  },

  // Financial - Journal Entries
  JOURNAL_ENTRIES: {
    VIEW: 'journal_entries.view',
    CREATE: 'journal_entries.create',
    UPDATE: 'journal_entries.update',
    DELETE: 'journal_entries.delete',
    POST: 'journal_entries.post',
  },

  // Banking
  BANKING: {
    VIEW: 'banking.view',
    RECONCILE: 'banking.reconcile',
    IMPORT: 'banking.import',
    MANAGE_ACCOUNTS: 'banking.manage_accounts',
  },

  // Reports
  REPORTS: {
    VIEW: 'reports.view',
    FINANCIAL: 'reports.financial',
    SALES: 'reports.sales',
    INVENTORY: 'reports.inventory',
    RENTAL: 'reports.rental',
    EXPORT: 'reports.export',
  },

  // CRM - Customers
  CUSTOMERS: {
    VIEW: 'customers.view',
    CREATE: 'customers.create',
    UPDATE: 'customers.update',
    DELETE: 'customers.delete',
  },

  // CRM - Vendors
  VENDORS: {
    VIEW: 'vendors.view',
    CREATE: 'vendors.create',
    UPDATE: 'vendors.update',
    DELETE: 'vendors.delete',
  },

  // Inventory - Products
  PRODUCTS: {
    VIEW: 'products.view',
    CREATE: 'products.create',
    UPDATE: 'products.update',
    DELETE: 'products.delete',
    MANAGE_PRICING: 'products.manage_pricing',
  },

  // Inventory - Warehouses
  WAREHOUSES: {
    VIEW: 'warehouses.view',
    CREATE: 'warehouses.create',
    UPDATE: 'warehouses.update',
    DELETE: 'warehouses.delete',
  },

  // Inventory - Stock
  STOCK: {
    VIEW: 'stock.view',
    ADJUST: 'stock.adjust',
    TRANSFER: 'stock.transfer',
    MOVEMENTS: 'stock.movements',
  },

  // Purchase Orders
  PURCHASE_ORDERS: {
    VIEW: 'purchase_orders.view',
    CREATE: 'purchase_orders.create',
    UPDATE: 'purchase_orders.update',
    DELETE: 'purchase_orders.delete',
    APPROVE: 'purchase_orders.approve',
  },

  // Goods Receipts
  GOODS_RECEIPTS: {
    VIEW: 'goods_receipts.view',
    CREATE: 'goods_receipts.create',
    UPDATE: 'goods_receipts.update',
    DELETE: 'goods_receipts.delete',
    POST: 'goods_receipts.post',
  },

  // Rental Management - Contracts
  RENTAL_CONTRACTS: {
    VIEW: 'rental_contracts.view',
    CREATE: 'rental_contracts.create',
    UPDATE: 'rental_contracts.update',
    DELETE: 'rental_contracts.delete',
    TERMINATE: 'rental_contracts.terminate',
  },

  // Rental Management - Visits
  VISITS: {
    VIEW: 'visits.view',
    CREATE: 'visits.create',
    UPDATE: 'visits.update',
    DELETE: 'visits.delete',
    SCHEDULE: 'visits.schedule',
    COMPLETE: 'visits.complete',
    PRINT: 'visits.print',
  },

  // Rental Management - Refills
  REFILLS: {
    VIEW: 'refills.view',
    CREATE: 'refills.create',
    UPDATE: 'refills.update',
    DELETE: 'refills.delete',
    RECORD: 'refills.record',
  },

  // Audit Logs
  AUDIT: {
    VIEW: 'audit.view',
    EXPORT: 'audit.export',
  },
} as const;
